import { User } from "../@core/data/users";

export default class Profile {
  id?: string;
  uid?: string;
  displayName?: string;
  email: string;
  photoURL?: string;

  fullName?: string;
  firstName?: string;
  lastName?: string;
  dob?: Date;
  gender?: number;
  mobile?: string;
  address?: string;
  schoolId?: string;
  fsId?: string;

  facebook?: string;
  instagram?: string;
  youtube?: string;
  twitter?: string;
  website?: string;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
